var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isShown)?_c('div',{staticClass:"toast",class:{'toast--alert': _vm.type == 'alert'}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }